import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { config } from '@/config';
import { AuthenticateApi } from '@/api'
import router from '@/router'

@Module({ namespaced: true })
class App extends VuexModule {

    appName: string = 'Transfer Planning';
    appVersion: string = config.version;
    menuLists: any[] = []
    masterMenuList: any[] = [
        {
            action: 'mdi-calendar-text-outline',
            active: false,
            items: [
                { 
                    tab: 'planning',
                    title: 'Transfer CR',
                    path: '/planning/transfercr',
                    profileCode: 'TFP-01',
                    isPermission: false
                },
                { 
                    tab: 'planning',
                    title: 'Transfer CR',
                    path: '/planning/transfercr',
                    profileCode: 'TFP-02' ,
                    isPermission: false
                },
                { 
                    tab: 'planning',
                    title: 'Transfer PJ',
                    path: '/planning/transferpj',
                    profileCode: 'TFP-03',
                    isPermission: false
                },
                { 
                    tab: 'planning',
                    title: 'Transfer PJ',
                    path: '/planning/transferpj',
                    profileCode: 'TFP-04',
                    isPermission: false
                }
            ],
            title: 'Planning',
        },
        {
            action: 'mdi-chart-box-outline',
            active: false,
            items: [
                { 
                    tab: 'report',
                    title: 'Tracking Transfer',
                    path: '/report/trackingtransfer',
                    profileCode: 'TFP-05',
                    isPermission: false
                },
                { 
                    tab: 'report',
                    title: 'Planning Report',
                    path: '/report/inspectionPlan',
                    profileCode: 'TFP-06',
                    isPermission: false
                },
                { 
                    tab: 'report',
                    title: 'Hierarchy Report',
                    path: '/report/hierarchy',
                    profileCode: 'TFP-07',
                    isPermission: false
                },
                { 
                    tab: 'report',
                    title: 'Bank Report',
                    path: '/report/bankcredit',
                    profileCode: 'TFP-08',
                    isPermission: false
                }
            ],
            title: 'Report',
        },
    ];

    @Mutation
    public async SET_MENU_LISTS (route: string) {
		console.log('SET_MENU_LISTS', route)
        if (!route.includes('/viewdata')){

            const getUserInfo = await AuthenticateApi.GetUserInfo();
            const permissions = getUserInfo?.permission
            if (permissions != null)
            {
                console.log("permissions", permissions)
                console.log("masterMenuList", this.masterMenuList)
                
                this.menuLists = this.masterMenuList
                // Update menu permissions
                this.menuLists = this.menuLists.map((menu: any) => {
                    return {
                        ...menu,
                        items: menu.items.map((item: any) => {
                            return {
                                ...item,
                                isPermission: permissions.filter(x => x.profileCode == item.profileCode).length > 0
                            }
                        })
                    }
                })
     
                //Filter menu items based on permissions
                this.menuLists = this.menuLists.map(menu => ({
                    ...menu,
                    items: menu.items.filter( (item : any) => item.isPermission)
                }));
    
                //Unique Menu
                const pathMap = new Map();
                this.menuLists = this.menuLists.map(menu => {
                    const filteredItems = menu.items.filter((item:any) => {
                        const key = `${item.path}`;
                        if (!pathMap.has(key)) {
                            pathMap.set(key, true);
                            return true;
                        }
                        return false;
                    });
                    return { ...menu, items: filteredItems };
                });
    
               
                // Set active menu
                let currentMenu = null
                this.menuLists.forEach(menu => {
                    menu.items.forEach( (item : any) => {
                        if (item.path === route) {
                            menu.active = true
                            currentMenu = item.path
                        }
                    })
                })
            console.log("currentMenu", currentMenu)
            console.log("this.menuLists", this.menuLists)
        
                //check permission route
                const isPublicRoute = route === "/" || route === "/login";
                if (currentMenu == null && !isPublicRoute) {
                    if (route != "/" && route != "/login") {
                        router.push("/")
                    }
                }
            }

        }
		
    }

    @Action
    public async MENU_LISTS(route: string) {
        this.context.commit("SET_MENU_LISTS", route)
    }
}

export default App;

